import Modifier from "../Modifier";
import DatePeriod from "../DatePeriod";

class ExtrapolateLinearModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'extrapolate_linear';
        this.steps = parameters.steps;
        this.span = parameters.span
    }

    compute(data, periodicity) {

        // get latest value
        if (data[data.length - 1] === undefined) {
            return data;
        }

        const x_n = data[data.length - 1].value;

        let steps = this.steps;
        if (this.span >= data.length) {
            steps = data.length + 1;
        }

        // get previous value
        // this point may no exists!
        if (data[data.length - this.span - 1] === undefined) {
            return data;
        }

        const x_nn = data[data.length - this.span - 1].value;

        // $b - startpunkt
        const b = x_n;

        // $m - steigung
        // delta y / delta x
        const delta_y = x_n - x_nn;
        const delta_x = this.span;
        const m = delta_x !== 0 ? delta_y / delta_x : 0;

        const begin = data[data.length - 1].time;

        // get dates!
        const dates = DatePeriod.grow(begin, periodicity, steps);

        _.forEach(dates, function (date, x) {
            data.push({
                time: date,
                value: m * (x + 1) + b,
            });
        });

        return data;
    }
}

export default ExtrapolateLinearModifier;
